import { Tooltip as SharedTooltip } from 'shared/components/Tooltip';

import type { FC } from 'react';
import type { TooltipProps } from 'shared/components/Tooltip';

export const Tooltip: FC<TooltipProps> = ({ children, ...props }) => (
  <SharedTooltip {...props} maxWidth={160}>
    {children}
  </SharedTooltip>
);
